// ------------ import internal dependencies ------------
import { instance } from "../instance";

interface Request {
  email: string;
  password: string;
}

/**
 * Handle user login
 * @param data
 * @returns
 */

export const login = async (data: Request) => {
  return instance({
    method: "post",
    url: "/auth/login",
    data,
  });
};

/**
 * Reset user password
 * @param data
 * @returns
 */
export const resetPassword = async (data: {
  email: Omit<Request, "password">;
}) => {
  return instance({
    method: "post",
    url: "/passwordReset/token",
    data,
  });
};

/**
 * Reset user password with token
 * @param data
 * @returns
 */
export const requestPasswordResetToken = async (data: {
  userId: string;
  loggedInUserId: string;
}) => {
  return instance({
    method: "post",
    url: "/requestPasswordReset/token",
    data,
  });
};

/**
 * Update user new password
 * @param data
 * @returns
 */
export const createPassword = async (data: Request) => {
  return instance({
    method: "post",
    // url: "/password/update",
    url: "/set/password",
    data,
  });
};

/**
 * Update user password from within app
 * @param data
 * @returns
 */
export const changeLoggedInUserPassword = async (data: Request) => {
  return instance({
    method: "post",
    url: "/password/update",
    data,
  });
};

/**
 * Update user new password
 * @param data
 * @returns
 */
export const forgotPassword = async (data: Request) => {
  return instance({
    method: "post",
    url: "/password/reset",
    data,
  });
};
